import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import {
  clientRead,
  locationRead,
  roleRead,
  staffRead,
  userRead,
} from "./app.constants";
import { AuthGuard } from "./core/auth/guards/auth-guard.service";
import { PrivilegeGuard } from "./core/auth/guards/privilege-guard.service";
import { AppLayoutComponent } from "./core/layouts/app-layout/app-layoutcomponent";
import { LoginLayoutComponent } from "./core/layouts/login-layout/login-layout.component";
import { ErrorPageComponent } from "./shared/components/error-page/error-page.component";

export const routes: Routes = [
  {
    path: "",
    component: AppLayoutComponent,
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./modules/home/home.module").then((m) => m.HomeModule),
        canActivate: [AuthGuard],
      },
      {
        path: "clients",
        loadChildren: () =>
          import("./modules/clients/clients.module").then(
            (m) => m.ClientsModule
          ),
        canActivate: [AuthGuard],
        canLoad: [PrivilegeGuard],
        data: { expectedPrivilege: clientRead },
      },
      {
        path: "staffs",
        loadChildren: () =>
          import("./modules/staffs/staffs.module").then((m) => m.StaffsModule),
        canActivate: [AuthGuard],
        canLoad: [PrivilegeGuard],
        data: { expectedPrivilege: staffRead },
      },
      {
        path: "users",
        loadChildren: () =>
          import("./modules/users/users.module").then((m) => m.UsersModule),
        canActivate: [AuthGuard],
        canLoad: [PrivilegeGuard],
        data: { expectedPrivilege: userRead },
      },
      {
        path: "roles",
        loadChildren: () =>
          import("./modules/roles/roles.module").then((m) => m.RolesModule),
        canActivate: [AuthGuard],
        canLoad: [PrivilegeGuard],
        data: { expectedPrivilege: roleRead },
      },
      {
        path: "locations",
        loadChildren: () =>
          import("./modules/locations/locations.module").then(
            (m) => m.LocationsModule
          ),
        canActivate: [AuthGuard],
        canLoad: [PrivilegeGuard],
        data: { expectedPrivilege: locationRead },
      },
      {
        path: "messages",
        loadChildren: () =>
          import("./modules/messages/messages.module").then(
            (m) => m.MessagesModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: "translations",
        loadChildren: () =>
          import("./modules/translation/translation.module").then(
            (m) => m.TranslationModule
          ),
      },
      {
        path: "audit-logs",
        loadChildren: () =>
          import("./modules/audit-logs/audit-logs.module").then(
            (m) => m.AuditLogsModule
          ),
        canActivate: [AuthGuard],
        canLoad: [PrivilegeGuard],
        data: { expectedPrivilege: clientRead },
      },
      {
        path: "property",
        loadChildren: () =>
          import("./modules/property/property.module").then(
            (m) => m.PropertyModule
          ),
      },
      {
        path: "changelogs",
        loadChildren: () =>
          import("./modules/changelogs/changelogs.module").then(
            (m) => m.ChangelogsModule
          ),
        canActivate: [AuthGuard],
        canLoad: [PrivilegeGuard],
        data: { expectedPrivilege: clientRead },
      },
      {
        path: "tokens",
        loadChildren: () =>
          import("./modules/mobile-token/mobile-token.module").then(
            (m) => m.MobileTokenModule
          ),
      },
      {
        path: "change-password",
        loadChildren: () =>
          import("./modules/change-password/change-password.module").then(
            (m) => m.ChangePasswordModule
          ),
        canActivate: [AuthGuard],
        canLoad: [PrivilegeGuard],
        data: { expectedPrivilege: clientRead },
      },
    ],
  },
  {
    path: "",
    component: LoginLayoutComponent,
    children: [
      {
        path: "login",
        loadChildren: () =>
          import("./modules/login/login.module").then((m) => m.LoginModule),
      },
      {
        path: "forgot-password",
        loadChildren: () =>
          import("./modules/forgot-password/forgot-password.module").then(
            (m) => m.ForgotPasswordModule
          ),
      },
    ],
  },
  {
    path: "**",
    component: ErrorPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
